module.exports = __webpack_public_path__ + "static/img/LOGO.a2f0379.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/LOGO.png
// module id = /MRp
// module chunks = 3